import { Inject, Injectable, OnDestroy } from '@angular/core'
import { AuthContextStorageService } from '../auth/auth-context-storage.service'
import { Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import { selectSelectedDepartment } from '../layout/state/main-view.selectors'

@Injectable({
    providedIn: 'root'
})
export class SelectedDepartmentService implements OnDestroy {

    selectedDepartment: any

    private savedDepartmentIdKey: string = '-lastSelectedDepartmentId'

    #selectSelectedDepartment: Subscription

    constructor(@Inject(Store) private store: Store,
                @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService) {

        this.#selectSelectedDepartment = this.store.select(selectSelectedDepartment).subscribe(data => {
            this.selectedDepartment = data
        })
    }

    ngOnDestroy() {
        this.#selectSelectedDepartment?.unsubscribe()
    }

    getSelectedDepartmentId(): number {
        return this.selectedDepartment
            ? this.selectedDepartment.id
            : null
    }

    getLastSelectedDepartment(): any {
        return JSON.parse(localStorage.getItem(this.authContextStorageService.getProjectKey() + this.savedDepartmentIdKey))
    }

    isDepartmentSelected(): boolean {
        return this.selectedDepartment
    }

    saveLastSelectedDepartment(department): void {
        localStorage.setItem(this.authContextStorageService.getProjectKey() + this.savedDepartmentIdKey, JSON.stringify(department))
    }

    updateFilterCriteriaDepartmentId(criteria: any): void {
        if (this.selectedDepartment) {
            criteria.departmentId = this.selectedDepartment.id
        } else {
            criteria.departmentId = null
        }
    }
}